import { render, staticRenderFns } from "./GroupPlansCompare.vue?vue&type=template&id=65f40380&lang=pug"
import script from "./GroupPlansCompare.vue?vue&type=script&lang=js"
export * from "./GroupPlansCompare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SimplePlanCompare: require('/home/docker/code/frontend/components/SimplePlanCompare.vue').default})
